import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { Draggable } from 'react-beautiful-dnd'

import { hiddenInPaging, getStageElementsByTypes, validateSearchResults } from '../../../functions'

import TableCell from './table-cell'

import SelectForm from '../select-form'

class TableRow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showDropdown: false
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { item, paging, stageElements } = nextProps

    if (item !== this.props.item) return true
    if (paging !== this.props.paging) return true
    if (stageElements !== this.props.stageElements) return true
    if (nextState !== this.state) return true
    return false
  }

  renderDropdown(item, parentItem) {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})} />

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              {/*<li onClick={() => this.setState({showDropdown: false})}>Change channel number</li>*/}
              {/*<li onClick={() => this.setState({showSelectForm: true, showDropdown: false})}>Rename instrument</li>*/}
              <li onClick={() => this.setState({showDropdown: false}, () => {
                parentItem && parentItem.children && parentItem.children.length <= 1
                ? this.props.deleteRiderItem(parentItem.id)
                : this.props.deleteRiderItem(item.id)
              })}>Remove this instrument</li>
            </ul>
          : null
        }
      </div>
    )
  }

  renderEmptyTableRow(columns, item, paging, stageElements, options, categories) {
    const { view } = this.props

    if (view.editable !== true) return null

    return (
      <div className="table-row table-row--empty">
        <div className="table-row-handle" />

        <div className="table-row-channel" />

        <div className="ui-dropdown" />

        <div className="table-row-item">
          {
            columns.map((column, index) => {
              if (paging.stickyColumn) {
                if (column.type !== 'instrument' && hiddenInPaging(paging, index)) return null
              } else {
                if (hiddenInPaging(paging, index)) return null
              }

              return (
                <div key={index} className="table-cell"
                  style={{minWidth: `${100/paging.size}%`, maxWidth: `${100/paging.size}%`}}>
                  {
                    column.type === 'instrument'
                    ? <SelectForm
                        group="input"
                        item={{
                          class: 'instrument',
                          position: item.position,
                          parent: item.parent,
                          type: item.type
                        }}
                        position={item.position}
                        placeholder={`Enter ${column.title.toLowerCase()}`}
                        promptTextCreator="Add"
                        typeSelectorText="Specify it's category"
                        itemGroups={this.props.itemGroups}
                        itemGroupingText="We suggest grouping drum elements into"
                        setFocus={true}
                        changeFocus={(e, current) => this.props.changeFocus(e, {...current, channel: current.channel+1})}
                        removeFocus={() => this.props.removeRiderItem(item)}
                        createRiderItem={this.props.createRiderItem}
                        editRiderItem={this.props.editRiderItem}
                        options={
                          options
                          ? options
                          : getStageElementsByTypes(['instrument'], stageElements)
                        }
                        categories={
                          categories
                          ? categories
                          : getStageElementsByTypes(['children'], stageElements.groups && stageElements.groups.instrument)
                        }
                        createStageElement={this.props.createStageElement}
                        searchResults={validateSearchResults(stageElements)}
                        getSearchResults={this.props.getSearchResults} />
                    : null
                  }
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  renderTableRow(item, parentItem, paging, stageElements, options, categories) {
    const { view } = this.props
    const { channel, row } = item

    return (
      <Draggable draggableId={item.id} isDragDisabled={!view.editable} type={this.props.dragDropType}>
        {(provided, snapshot) => (
          <div className="table-row">
            <div className="table-row--draggable"
              ref={provided.innerRef}
              style={provided.draggableStyle} >
              <div className="table-row-handle" {...provided.dragHandleProps} tabIndex="-1" />

              <div className="table-row-channel">
                {item.channel}
              </div>

              {
                view.editable
                ? this.renderDropdown(item, parentItem)
                : null
              }

              <div className="table-row-item">
                {
                  row.map((item, index) => {
                    if (paging.stickyColumn) {
                      if (item.class !== 'instrument' && hiddenInPaging(paging, index)) return null
                    } else {
                      if (hiddenInPaging(paging, index)) return null
                    }

                    return (
                      <TableCell key={index}
                        view={view}
                        group={this.props.group}
                        channel={channel}
                        item={item}
                        cellIndex={index}
                        paging={paging}
                        itemGroups={this.props.itemGroups}
                        changeFocus={(e, current) => this.props.changeFocus(e, {...current, channel})}
                        createRiderItem={this.props.createRiderItem}
                        editRiderItem={this.props.editRiderItem}
                        deleteRiderItem={this.props.deleteRiderItem}
                        stageElements={this.props.stageElements}
                        options={options}
                        categories={categories}
                        createStageElement={this.props.createStageElement}
                        getSearchResults={this.props.getSearchResults} />
                    )
                  })
                }
              </div>
            </div>

            {provided.placeholder}

            {
              view.editable
              ? <div className="table-row-separator" onClick={() => {
                  this.props.addRiderItem({
                    class: "instrument",
                    position: item.position+1,
                    parent: item.parent || null,
                    indexes:
                      this.props.parentRowIndex !== undefined
                      ? [
                          this.props.parentRowIndex,
                          this.props.rowIndex+1
                        ]
                      : [
                          this.props.rowIndex+1
                        ]
                  })
                }}>
                  <button className="button--add-row oval-button" data-value="Insert row" tabIndex="-1" />
                </div>
              : null
            }
          </div>
        )}
      </Draggable>
    )
  }

  render() {
    const { columns, item, parentItem, paging, stageElements, options, categories } = this.props

    return item.id !== undefined
    ? this.renderTableRow(item, parentItem, paging, stageElements, options, categories)
    : this.renderEmptyTableRow(columns, item, paging, stageElements, options, categories)
  }
}

TableRow.propTypes = {
  view: PropTypes.object,
  dragDropType: PropTypes.string,
  group: PropTypes.string,
  columns: PropTypes.array,
  item: PropTypes.object,
  rowIndex: PropTypes.number,
  parentItem: PropTypes.object,
  parentRowIndex: PropTypes.number,
  paging: PropTypes.object,
  itemGroups: PropTypes.array,
  changeFocus: PropTypes.func,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  moveRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  stageElements: PropTypes.object,
  options: PropTypes.array,
  categories: PropTypes.array,
  createStageElement: PropTypes.func,
  getSearchResults: PropTypes.func
}

TableRow.defaultProps = {
  view: {},
  dragDropType: '',
  group: '',
  columns: [],
  item: {},
  rowIndex: undefined,
  parentItem: {},
  parentRowIndex: undefined,
  paging: {},
  itemGroups: [],
  changeFocus: function() {},
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  editRiderItem: function() {},
  moveRiderItem: function() {},
  deleteRiderItem: function() {},
  stageElements: {},
  options: undefined,
  categories: undefined,
  createStageElement: function() {},
  getSearchResults: function() {}
}

export default TableRow



// WEBPACK FOOTER //
// ./src/components/rider/rider-input/input-table/table-row.js